import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../common/components/base_form_controlled_modal";
import { DefaultFormMultiAutocomplete } from "../../../../common/components/default_form_multi_autocomplete";
import { zodResolver } from "@hookform/resolvers/zod";
import { ObraAreaDropDown } from "../../domain/models/obra_area_dropdown";
import { ObraServicoDropDown } from "../../domain/models/obra_servico_dropdown";
import { ReportChecklistForm, ReportChecklistSchema } from "../schemas/Obras_informacoesgerais/report_checklist";
import { DefaultFormAutocomplete } from "../../../../common/components/default_form_autocomplete";

import FormContainer from "../../../../common/components/form_container";

/**
 * ReportChecklistModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  obraAreasDropDown: ObraAreaDropDown[],
  obraServicosDropDown: ObraServicoDropDown[],
  onClose: (openState: boolean) => void;
  onSubmit: (form: ReportChecklistForm) => void;
};

export const ReportChecklistModal = ({
  open,
  saving,
  loading,
  obraAreasDropDown,
  obraServicosDropDown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ReportChecklistForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ReportChecklistSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Relatório de Checklist'
      confirmButtonLabel="Gerar relatório"
      confirmSavingButtonLabel="Gerando relatório..."
      savingLabel="Carregando..."
      width="50rem"
      onClose={() => onClose(false)}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title={"Informações"} arrangement="fullRow">
        <>
          <DefaultFormAutocomplete
            name='area'
            label='Área'
            required={true}
            options={obraAreasDropDown}
            getOptionKey={x => x.idObraAreaChecklist}
            getOptionLabel={x => x.descricao}
            reactHookForm={hookForm} />

          <DefaultFormMultiAutocomplete
            name='servico'
            label='Serviço'
            chipMaxLength={60}
            options={obraServicosDropDown}
            getOptionKey={x => x.idChecklistServico}
            getOptionLabel={x => x.descricao}
            reactHookForm={hookForm} />

        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}